
class DropDownItem {
    value: string;
    title: string;

    constructor(value: string, title: string) {
        this.value = value;
        this.title = title;
    }
}

export default DropDownItem;
